import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import RankSection from "./components/RankSection";
import CategoryFeed from "./components/CategoryFeed";
import Timeline from "./components/Timeline";
import Featured from "./components/Featured";
import Faq from "./components/Faq";
import About from "./components/About";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <RankSection />
        <CategoryFeed />
        <Timeline />
        <Featured />
        <Faq />
        <About />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}